enum HttpMethodEnum {
    GET = 'GET',
    POST = 'POST',
    PUT = 'PUT',
    DELETE = 'DELETE',
    PATCH = 'PATCH',
}

enum RouteTypeEnum {
    COMMON = 'common',
    PAYMENT = 'payment',
    HOTEL = 'hotel',
    FASHION = 'fashion',
    FOOD = 'food',
}

enum ResourceTypeEnum {
    AUTHENTICATION = 'Authentication',
    STORE_MANAGEMENT = 'Store Management',
    PAYMENT_PROCESSING = 'Payment Processing',
    CUSTOMER_MANAGEMENT = 'Customer Management',
    HOTEL_MANAGEMENT = 'Hotel Management',
    PRODUCT_MANAGEMENT = 'Product Management',
    FOOD_MANAGEMENT = 'Food Management',
    CONFIGURATION = 'Configuration',
    SECURITY = 'Security',
    LOCALIZATION = 'Localization',
    COMMENTS = 'Comments',
    MESSAGING = 'Messaging',
}

type SwaggerRoutes = {
    id: number;
    url: string;
    method: HttpMethodEnum;
    operationId: string;
    tag: string;
    type: RouteTypeEnum;
    description: string;
    secured: boolean;
    resourceType: ResourceTypeEnum;
    status: boolean;
    isAdminOnly: boolean;
    notes:string;
    created: string;
    updated: string;
}

type FilterPluginspaceDto = {
    search?: string
    status?: { label: string; value: number }
    type?: { label: string; value: string }
}

type FilterPluginspace = {
    status?: boolean
 type?: string
}

type TableParams = {
  page?: number
  pageSize?: number
  search?: string
  sorting?: { field: string; direction: 'asc' | 'desc' }
  filters?: FilterPluginspaceDto
}

type PluginSpace = {
  id: number
  name: string
  type: string
  subdomain: string
  status: string
  active: boolean
  created: Date
  cnpj: string
}

type UserType = {
  id: number
  image: string
  name: string
  email: string
  type: string
  created: string
  status: boolean
  cpf: string
}

type FilterUserDto = {
    search?: string
    status?: { label: string; value: number }
    type?: { label: string; value: string }
}

type FilterUser = {
    search?: string
    status?:boolean
    type?: string
}


type SwaggerPermission = {
    id: number
    userId: number
    swaggerRouteId: number
    created: string
    updated: string
}
export type {SwaggerRoutes,FilterPluginspace, FilterUserDto,FilterUser, UserType, FilterPluginspaceDto,TableParams,PluginSpace, SwaggerPermission}
export { HttpMethodEnum, RouteTypeEnum, ResourceTypeEnum }